import React from 'react';
import PropTypes from 'prop-types';

import ZRCalloutInfoTooltip from '../../ZRCalloutInfoTooltip';

import './ZRSwitchField.less';

function switchSpan(checked) {
  return (
    <span
      className={`zr_switch zrSwitch-switch ${checked ? 'zr_switch_checked zrSwitch-checked' : ''}`}
    />
  );
}

/**
 * ZRSwitch component that is compatible with Redux Form.
 */
export function ZRSwitchField({ input, label, tooltip, buttonLeftOfLabel }) {
  const id = `zr_switch_field_${input.name}`;
  const checked = !!+input.value;

  return (
    <div className="zr_switch_field">
      <input
        {...input}
        checked={checked}
        className="zr_switch_input zrSwitch-input"
        id={id}
        type="checkbox"
      />
      <label htmlFor={id} className="zr_switch_label">
        { buttonLeftOfLabel && switchSpan(checked) }
        <span className="zr_label_tooltip_container">
          {label}
          { tooltip && (
            <ZRCalloutInfoTooltip id="zr_switch_tooltip" title={tooltip} />
          )}
        </span>
        { !buttonLeftOfLabel && switchSpan(checked) }
      </label>
    </div>
  );
}

ZRSwitchField.propTypes = {
  /** Connects your input component to Redux whose props are destructured into your `<input/>` component. */
  input: PropTypes.shape({
    /** Returns the name prop that you passed in. */
    name: PropTypes.string,
    value: PropTypes.oneOf([PropTypes.bool, '0', '1']),
  }).isRequired,

  /** Checkbox label. */
  label: PropTypes.string.isRequired,

  /** Tooltip text. */
  tooltip: PropTypes.string,

  buttonLeftOfLabel: PropTypes.bool,
};

ZRSwitchField.defaultProps = {
  tooltip: '',
  buttonLeftOfLabel: true,
};

export default ZRSwitchField;
